<template>
    <div>
        <div class="heade_top">
            <el-button type="primary" size="small" @click="addList">添加驳回理由</el-button>
            <div class="box">
                <el-select v-model="classNameCode" placeholder="分类名" size="small" clearable>
                    <el-option
                    v-for="item in options"
                    :key="item.id"
                    :label="item.paramValue"
                    :value="item.paramCode" >
                    </el-option>
                </el-select>
                <el-input
                    style="width: 300px; margin-left: 20px"
                    placeholder="请输入驳回理由关键字"
                    v-model="rejectReasonContent"
                    clearable size="small">
                </el-input>
                <el-button type="primary" size="small" @click="sumFunc" style="margin-left: 20px">搜索</el-button>
            </div>
        </div>

        <div class="table_box">
            <el-table
            :data="tableData"
            stripe
            border
            size="small"
            align="center"
            header-align="center"
            style="width: 100%">
            <el-table-column
            type="index"
            :index="indexMethod"
            label="序号">
            </el-table-column>
            <el-table-column
            prop="rejectReasonContent"
            label="驳回理由">
            </el-table-column>
            <el-table-column
            prop="rejectReasonCode"
            label="理由编码">
            </el-table-column>
            <el-table-column
            prop="className"
            label="分类名">
            </el-table-column>
            <el-table-column
            prop="reasonType"
            label="理由类型">
            <template slot-scope="scope">
                {{scope.row.reasonType==='subject'?'主观驳回理由':'客观驳回理由'}}
            </template>
            </el-table-column>
            <el-table-column
            prop="updateTime"
            label="最后修改时间">
            </el-table-column>
            <el-table-column
            fixed="right"
            label="操作"
            width="100">
            <template slot-scope="scope">
                <el-button @click="handleClick(scope.row)" type="text" size="small">编辑</el-button>
                <el-button  v-if="!isBtn('reasonRejectionDeleteBtn:true')" @click="deleteFunc(scope.row.id)" type="text" size="small">删除</el-button>
            </template>
            </el-table-column>
            </el-table>


            <div class="pages">
                <el-pagination
                    background
                    :total="total"
                    @current-change="handleSizeChange"
                    @size-change="handleCurrentChange"
                    layout="total, sizes, prev, pager, next, jumper"
                    :current-page="currentPage1"
                    :page-size="pageSize1"
                ></el-pagination>
            </div>
        </div>



        <!-- 弹窗 -->
        <el-dialog
            :title="diaTitles"
            :visible.sync="dialogVisible"
            width="30%"
            :before-close="handleClose">
            <div class="from_mian">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="140px" class="demo-ruleForm">
             
                <el-form-item label="分类名" prop="classNameCode">
                    <el-select v-model="ruleForm.classNameCode" placeholder="分类名" size="small" clearable>
                      <el-option
                        v-for="item in options"
                        :key="item.id"
                        :label="item.paramValue"
                        :value="item.paramCode" >
                      </el-option>
                  </el-select>
                </el-form-item>
              
         
                <el-form-item label="理由类型" prop="reasonType">
                    <el-radio-group v-model="ruleForm.reasonType" size="small">
                        <el-radio label="subject">主观驳回理由</el-radio>
                        <el-radio label="objective">客观驳回理由</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="驳回理由内容" prop="rejectReasonContent" size="medium">
                    <el-input type="textarea" v-model="ruleForm.rejectReasonContent"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitForm('ruleForm')" size="small">确定</el-button>
                    <el-button @click="dialogVisible = false" size="small">取消</el-button>
                </el-form-item>

                </el-form>

            </div>
            </el-dialog>
      
    </div>
</template>
<script>
import { getLoginUser } from "@/utils/auth";
export default {
  name: "",
  mixins: [],
  data() {
    return {
      indexMethod: 1,
      diaTitles:'新增驳回理由',
      rejectReasonContent:'',
      options: [],
      currentPage1: 1,
      pageSize1: 10,
      total: 10,
      tableData: [
      ],
      input1: "",
      dialogVisible: false,
      ruleForm: {
        classNameCode: "",
        reasonType: "",
        rejectReasonContent: "",
      },
      rules: {
        classNameCode: [
          { required: true, message: "请选择分类名", trigger: "change" },
        ],
        reasonType: [
          { required: true, message: "请选择理由类型", trigger: "change" },
        ],
        rejectReasonContent: [{ required: true, message: "请输入驳回内容", trigger: "blur" }],
      },
      classNameCode: "",
    };
  },
  async created() {
    await this.getListByConfigClass();
    this.queryRejectPageList();
  },
  mounted() {},
  methods: {
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    handleSizeChange(val) {
        this.currentPage1 = val;
        this.queryRejectPageList();
        console.log(val)
    },
    handleCurrentChange(val) {
        this.currentPage1 = 1;
        this.pageSize1 = val;
        this.queryRejectPageList();
        console.log(`当前页: ${val}`);
    },
    isBtn(code) {
      return this.isShowBtn(code);
    },
    // 删除
    deleteFunc(id){
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async() => {
          const {code} = await this.$store.dispatch("delRedpackageRejectReason", {
            id:id
          });
            if(code == 0){
              this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.currentPage1 = 1;
            this.queryRejectPageList();
          }
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
    },
    // 提交
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          console.log(this.ruleForm);
          const {code, result} = await this.$store.dispatch("addOrUpdateRedpackageRejectReason", this.ruleForm);
          if(code == 0){
            this.$message.success("操作成功");
            this.queryRejectPageList();
            this.dialogVisible = false;
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //编辑
     handleClick(row){
      console.log(row.reasonType);
      this.ruleForm = {
        classNameCode:  row.classNameCode,
        reasonType: row.reasonType,
        rejectReasonContent: row.rejectReasonContent,
        id: row.id,
      };
      this.diaTitles = '编辑驳回理由';
      this.dialogVisible = true;
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    //获取列表
    async queryRejectPageList(){
        const { storeCode } = getLoginUser();
        const {code, result} = await this.$store.dispatch("queryRejectPageList", {
            pageNo: this.currentPage1,
            pageSize : this.pageSize1,
            classNameCode: this.classNameCode,
            rejectReasonContent: this.rejectReasonContent
         });
         if (code == 0) {
           this.tableData = result.records;
           this.total = result.total;
         }
    },
    // 获取分类名
    async getListByConfigClass(){
      const { storeCode } = getLoginUser();
      const { code, result } = await this.$store.dispatch("getListByConfigClass", {
        storeCode : storeCode,
        configClass : "redpackage_reject_reason"
      })
      if(code == 0){
        this.options = result;
      }
    },
    addList(){
      this.dialogVisible = true; 
      this.currentPage1 = 1;
      this.diaTitles='新增驳回理由';
      this.ruleForm = {};
    },
    sumFunc(){
      this.currentPage1 = 1;
      this.queryRejectPageList();
    }
  },
};
</script>

<style lang='scss' scoped>
.heade_top {
  width: 100%;
  background-color: #fff;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.table_box {
  min-height: 600px;
  background-color: #fff;
  margin-top: 20px;
  padding: 20px;
  box-sizing: border-box;
  position: relative;
  padding-bottom: 100px;
  .pages {
    position: absolute;
    bottom: 20px;
    left: 37%;
  }
}
</style>
